import { useState } from "react";
import {
  useFeatureFlagList,
  useFeatureFlagManager,
  useFeatureFlagValue,
} from "../../config/FeatureFlagManager/hooks.ts";
import { LabsModal } from "./LabsModal.tsx";
import styles from "../AppBar/AppBar.module.css";
import { LabsIcon } from "../AppBar/LabsIcon.tsx";

export const ConnectedLabsModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const featureFlagManager = useFeatureFlagManager();
  const featureList = useFeatureFlagList();
  const isLabsEnabled = useFeatureFlagValue("enableLabs");
  if (!isLabsEnabled) return null;

  return (
    <>
      <button onClick={() => setIsOpen(true)} className={styles.IconButton}>
        <LabsIcon />
      </button>
      <LabsModal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        featureFlagManager={featureFlagManager}
        featureList={featureList}
      />
    </>
  );
};
